import React from 'react'
import { Divider, Button } from '@fs/zion-ui'
import { useTranslation } from 'react-i18next'
import { ContentHistory } from '@fs/zion-icon'
import { useSlsStateContext } from '@fs/zion-sls'
import { useR2StateContext } from '../../../../providers/r2Provider/R2Context'

/**
 * ShowChangeHistory
 *
 * Renders a button that navigates to the change history view for the current image.
 * Optionally displays an icon and divider above the button.
 * Includes the selected person ID in the URL if one is selected.
 *
 * @component
 * @param {Object} props
 * @param {boolean} [props.showIcon=true] - Whether to display the ContentHistory icon on the button
 * @param {boolean} [props.showDivider=true] - Whether to display a divider above the button
 * @returns {JSX.Element}
 */
export default function ShowChangeHistory({ showIcon = true, showDivider = true }) {
  const state = useSlsStateContext()
  const r2State = useR2StateContext()
  const [t] = useTranslation()

  return (
    <>
      {showDivider && <Divider marginY="nano" fullWidth />}
      <Button
        Icon={showIcon ? ContentHistory : undefined}
        to={`/ark:/61903/${state.currentImageArk}?view=history${
          r2State.selectedPersonId ? `&personArk=${r2State.selectedPersonId}` : ''
        }`}
      >
        {t('view-history-show-change-history-button', 'Show Change History')}
      </Button>
    </>
  )
}
